__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@cocounsel/mytikas-mfe-client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@cocounsel/prometheus/material", "3.0.138", () => (Promise.all([__webpack_require__.e(141), __webpack_require__.e(783)]).then(() => (() => (__webpack_require__(4141))))));
			register("@cocounsel/prometheus", "3.0.138", () => (Promise.all([__webpack_require__.e(448), __webpack_require__.e(141), __webpack_require__.e(702), __webpack_require__.e(783), __webpack_require__.e(644)]).then(() => (() => (__webpack_require__(7702))))));
			register("@openfeature/react-sdk", "0.4.11", () => (() => (__webpack_require__(9663))), 1);
			register("@tanstack/react-query", "5.100.1", () => (() => (__webpack_require__(5946))), 1);
			register("axios", "1.20.0", () => (__webpack_require__.e(396).then(() => (() => (__webpack_require__(8396))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(543).then(() => (() => (__webpack_require__(2543))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-use-measure", "2.1.7", () => (__webpack_require__.e(688).then(() => (() => (__webpack_require__(4688))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			register("zone.js", "0.14.10", () => (() => (__webpack_require__(8216))), 1);
			register("zustand", "4.5.7", () => (() => (__webpack_require__(4085))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};